import swal from 'sweetalert';

class IdleTimeContainer {
  constructor({ inactivityTime, expirationTime, onTimeout, onExpired }) {
    this.inactivityTime = inactivityTime;
    this.expirationTime = expirationTime
    this.onTimeout = onTimeout;
    this.onExpired = onExpired;
    this.timeoutCountdown = 15
    this.isInitialRender = true;

    this.inactivityTimeout = null;
    this.expirationTimeout = null;

    this.startTimer();
    this.tracker();
  }

  startTimer(){
    if (this.inactivityTimeout === null) {
      this.resetInactivityTimer();
    }
    this.resetExpirationTimer();
  }

  resetInactivityTimer(e) {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }
    
    this.inactivityTimeout = setTimeout(() => {
      if(window.location.pathname !== '/login'){
      this.handleInactivityTimeout(e);
      }
    }, this.inactivityTime * 1000);
  }

  resetExpirationTimer() {
    if (this.expirationTimeout) {
      clearTimeout(this.expirationTimeout);
    }

    this.expirationTimeout = setTimeout(() => {
      this.handleExpiration();
    }, this.expirationTime * 1000);
  }


  handleInactivityTimeout(e) {
    if (this.onTimeout) {
      const span = document.createElement("span");

    const updateSpanContent = (timeoutCountdown) => {
      span.innerHTML = `The current session is about to expire in <code>${timeoutCountdown}</code> seconds.\n Would you like to continue the session?`;
    };

    if (this.isInitialRender) {
        updateSpanContent(this.timeoutCountdown); // Initial invocation
        this.isInitialRender = false; // Set the flag to false
      } else {
        return 
      }

      const countdownInterval = 
      setInterval(() => {
          if (this.timeoutCountdown > 1) {
              this.timeoutCountdown--;
          updateSpanContent(this.timeoutCountdown);
        } else {
          clearInterval(countdownInterval);
        this.timeoutCountdown = 15
          swal.close();   
          this.onTimeout();
          this.logout();
        }
      }, 1000);






      this.alertInstance = swal({
        html: true,
        title: 'Session Timeout',
        backdrop:true,
        allowOutsideClick: false,
        closeOnClickOutside: false,
        content: span,
        closeOnEsc: false, 
        icon: "warning",
        buttons: ["Logout", "Continue Session"],
        dangerMode: true,
      }).then((continueSession) => {
        clearInterval(countdownInterval);
        this.timeoutCountdown = 15
        if (continueSession) {
          this.resetInactivityTimer();
          this.isInitialRender = true; // Set the flag to false
        } else {
          this.onTimeout();
          this.logout();
        }
      });
    }
  }

  handleExpiration() {
    if (this.onExpired) {
      if (this.alertInstance) {
        swal.close();
      }
      this.onExpired();
      this.logout();
    }
  }

  tracker() {
    const events = ["mousemove", "scroll", "keydown", "click"];
    events.forEach((event) => {
      window.addEventListener(event, () => {
        this.resetInactivityTimer(event);
      });
    });
  }

  logout() {
    const events = ["mousemove", "scroll", "keydown", "click"];
    events.forEach((event) => {
      window.removeEventListener(event, () => {
        this.resetInactivityTimer();
      });
    });
    console.log("User logged out");
  }
}

export default IdleTimeContainer;
